import { Engagements } from './Engagement/Engagements';
import { NewClient } from './Client/NewClient';
import { ReacceptanceClientListModel } from './ReacceptanceClientListModel';

export class InitiateReacceptanceEngagementsViewModel {
   client:NewClient;
   engagement:Engagements;
   reacceptanceEngagement:ReacceptanceClientListModel;
}